<template>
  <video
    v-if="isVideo"
    :class="{ 'aspect-square object-cover': preview }"
    :src="src"
    :title="name"
    :controls="controls"
    :preload="preload"
    @loadedmetadata="$emit('loaded')"
  />
  <img
    v-else
    :class="{ 'aspect-square object-cover': preview }"
    :src="src"
    :alt="name"
    @load="$emit('loaded')"
  />
</template>

<script setup>
import { computed } from "vue";

defineEmits(["loaded"]);

const props = defineProps({
  src: { type: String, required: true },
  type: { type: String, required: false },
  name: { type: String, default: "" },
  controls: { type: Boolean, required: false },
  preload: { type: String, default: "none" },
  preview: { type: Boolean, required: false },
});

const isVideo = computed(() => props.type?.includes("video"));
</script>
